import React, { useEffect } from 'react';
import AuthHeader from '../../components/header/AuthHeader';
import BannerRight from '../../components/BannerRight';
import AuthWrapper from '../../components/AuthWrapper';
import rocketBoyImg from '../../assets/images/barbfullLogo.png';
import { useTrackingContext } from '../../context/trackingContext';
import Footer from '../../components/Footer';
import useClient from '../../hooks/useClient';
import config from '../../config';
import { useLocation, useSearchParams } from 'react-router-dom';

const ParentalConsentThankYou = () => {
  const { trackPageView } = useTrackingContext();
  const client = useClient();
  const { search } = useLocation();
  const [_params, setParams] = useSearchParams();

  useEffect(() => {
    trackPageView({
      pageName: 'Parental Thank You confrimation screen'
    });
  }, []);

  const consumeConsent = async (code) => {
    await client.patch(`${config.everywhereApi}/users/pending-parental-consent`, {
      code
    });
  };

  useEffect(() => {
    const query = new URLSearchParams(search);

    const consentCode = query.get('code');

    if (consentCode) consumeConsent(consentCode);
    // Clear consumed query strings
    setParams({});
  }, []);

  return (
    <div className="flex h-screen overflow-hidden">
      <div className="w-full lg:w-1/2 relative overflow-y-scroll left-form">
        <AuthHeader />
        <AuthWrapper className="max-w-sm">
          <div id="unable-view-ip">
            <img src={rocketBoyImg} alt="build rocket boy" className="w-full mb-8" />
            <h6 className="font-Korolev-Bold text-xl text-black text-center uppercase m-1">
              THANK YOU
            </h6>
            <p className="text-black text-center font-Korolev-Medium text-base mb-5">
              We have received your parent/guardian consent and notified your child via email.
            </p>
          </div>
        </AuthWrapper>
        <Footer />
      </div>
      <BannerRight />
    </div>
  );
};

export default ParentalConsentThankYou;
